import { message } from "skin/event";
import { status } from "skin/event/status";

const checkimg = (obj, form, story, data, d, action) => {
	console.log("[Сайт - форма] событие", obj);
	switch (obj.name) {
		case "logotype":
			return fn(obj, data);
		default:
			return status.action;
	}
};

export default checkimg;

// Проверка формата файла и его размера
function fn(obj, data) {
	const file = obj.value ? obj.value.get(obj.name) : null;
	if (!file) return status.action;
	const ftype = file.name.split(".").reverse()[0];
	const img = new Image();
	img.src = URL.createObjectURL(file);
	img.onload = () => {
		const { width: w, height: h } = img;
		const isSquare = w === h;
		data.setValue("size", `${w}:${h}`);
		URL.revokeObjectURL(img.src);

		if (ftype?.toLowerCase() !== "png") {
			message("Файл должен быть в формате png", "внимание");
			return status.ignore;
		}
		if (w < 500 || h < 500) {
			message(`Ширина и высота картинки должна быть больше 500px. Ваши размеры по ширине ${w}, по высоте ${h}`);
			return status.ignore;
		}
		if (!isSquare) {
			message(`Размер картинки с width: ${w} и height: ${h} не имеет соотношение 1:1`, "внимание");
			return status.ignore;
		}
	};
}
